import React from "react";
import "moment/locale/ru";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

export default class EssenceReferenceSchedulerEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editData: {},
    };
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.init();
    }
  }

  init = () => {
    const editData = this.props.data;
    this.setState(
      {
        editData,
      },
      () => this.triggerChange()
    );
  };

  dateTimeChange = (key, value) => {
    if (value instanceof Object) {
      this.setState(
        (state) => {
          let editData = state.editData;
          editData[key] = value.toDate();
          return { editData };
        },
        () => this.triggerChange()
      );
    }
  };

  onChange = (key, value) => {
    this.setState(
      (state) => {
        let editData = state.editData;
        editData[key] = value;
        return { editData };
      },
      () => this.triggerChange()
    );
  };

  triggerChange = () => {
    if (this.props.onChange) {
      let changeData = {
        period: this.state.editData.period,
        datestart: this.state.editData.datestart,
        datestop: this.state.editData.datestop,
      };
      this.props.onChange(changeData);
    }
  };

  render() {
    const editData = this.state.editData || {};
    return (
      <>
        <div className="row">
          <div className="col-lg-6">
            <div className="form-group">
              <label>Дата и время начала:</label>
              <Datetime
                value={editData.datestart ? new Date(editData.datestart) : ""}
                onChange={(v) => this.dateTimeChange("datestart", v)}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>Дата и время окончания:</label>
              <Datetime
                value={editData.datestart ? new Date(editData.datestop) : ""}
                onChange={(v) => this.dateTimeChange("datestop", v)}
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-group">
              <label>Период:</label>
              <input
                onChange={(e) => this.onChange("period", e.target.value)}
                className="form-control"
                value={editData.period || ""}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}
